import React from 'react';
import qs from "query-string";
import {withRouter} from 'react-router-dom'
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux'

import {getToken, removeToken, setToken, isValidToken} from '../token_management'
import * as actions from '../application.actions';
import * as selectors from '../application.selectors';
import Unauthorized from './401';

export default function (WrappedComponent) {
  class Authentication extends React.Component {
    state = {isAuthenticated: false, completedAuthCheck: false, token: undefined};
    intervalId = undefined;

    componentDidMount() {
      const {actions: {getEpasrrUrl}} = this.props;
      getEpasrrUrl();
      this.acceptIncomingToken();
    }

    componentWillUpdate(nextProps) {
      /**
       * If we have our epasrr url, or it has changed, check the token every 30 seconds
       */
      if (this.props.epasrrUrl !== nextProps.epasrrUrl) {
        this.ensureAuthentication();
        this.intervalId = setInterval(this.checkToken, 30000);
      }
    }

    /**
     * If the token is no longer valid, call the unauthorized action.
     */
    checkToken = () => {
      if (!isValidToken()) {
        clearInterval(this.intervalId);
        this.props.actions.unauthorized()
      }
    };

    /**
     * Checks the hash value of the path. If it contains a token,
     * save it, and replace the current path to hide the hash.
     */
    acceptIncomingToken = () => {
      const {location: {hash, pathname}, history} = this.props;
      const values = qs.parse(hash);
      let token = null;
      if (Boolean(values.token)) {
        token = values.token;
        history.replace(pathname);
      } else {
        token = getToken();
      }
      setToken(token);
      this.setState({token, completedAuthCheck: true});
    };

    ensureAuthentication = () => {
      if (isValidToken()) {
        const {actions: {logUserIn}} = this.props;
        this.setState({isAuthenticated: true}, () => logUserIn())
      }
    };

    render() {
      const {completedAuthCheck, token} = this.state;

      if (!completedAuthCheck)
        return null;

      const authorized = isValidToken(token);
      if (!authorized) removeToken();

      return authorized
        ? <WrappedComponent {...this.props} />
        : <Unauthorized/>;
    }
  }

  return withRouter(
    connect(
      (state) => ({epasrrUrl: selectors.epasrrUrl(state)}),
      dispatch => ({actions: bindActionCreators({...actions}, dispatch)})
    )(Authentication)
  );
}


// WEBPACK FOOTER //
// ./src/components/authenticated.js